import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=335076c6&scoped=true&"
import script from "./Customization.vue?vue&type=script&lang=js&"
export * from "./Customization.vue?vue&type=script&lang=js&"
import style0 from "./Customization.vue?vue&type=style&index=0&id=335076c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335076c6",
  null
  
)

export default component.exports